import { SERVER_URL } from '../../../config/envConf';

/* inline style */
const COLOR_PRIMARY = '#18266D';

/* API route */
const ACCESS_TYPE = 'SVJWT';
const VENDING_URL = `${SERVER_URL}vending/api/`;

/* Validation Message when input format is incorrect
* change anything here to change UI/UX about error message
*  */
const yupErrorMsg = {
  // Auth
  USERNAME_EMPTY: 'Username can\'t be empty',
  PASSWORD_EMPTY: 'Password can\'t be empty',
  CONFIRM_PASS_EMPTY: 'Confirm password can\'t be empty',
  FIRST_NAME_EMPTY: 'First name can\'t be empty',
  LAST_NAME_EMPTY: 'Last name can\'t be empty',
  PHONE_NUMBER_EMPTY: 'Phone number can\'t be empty',
  POSITION_EMPTY: 'Position can\'t be empty',
  COMPANY_NAME_EMPTY: 'Company name can\'t be empty',
  STREET_ADDRESS_EMPTY: 'Street address can\'t be empty',
  CITY_EMPTY: 'City can\'t be empty',
  STATE_EMPTY: 'State can\'t be empty',
  ZIP_CODE_EMPTY: 'Zip code can\'t be empty',
  EMAIL_EMPTY: 'Email can\'t be empty',

  PASSWORD_INCORRECT_FORMAT: 'Password must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
  EMAIL_INCORRECT_FORMAT: 'Email format is incorrect',
  ZIP_CODE_INCORRECT_FORMAT: 'Zip code must exactly 5 number',

  PASSWORD_NOT_MATCH: 'Password not match',

  // Vending Machine
  DEVICE_ID_EMPTY: 'Device id can\'t be empty',
  CLIENT_EMPTY: 'Client can\'t be empty',
  LOCATION_EMPTY: 'Location can\'t be empty',
  MODEL_EMPTY: 'Machine model can\'t be empty',
  MACHINE_CONFIG_EMPTY: 'Machine configuration can\'t be empty',
  PRICE_EMPTY: 'Price can\'t be empty',
  PRODUCT_EMPTY: 'Product can\'t be empty',
  MODEL_NAME_EMPTY: 'Model name can\'t be empty',
  MACHINE_TYPE_EMPTY: 'Machine type can\'t be empty',
  CONFIG_NAME_EMPTY: 'Configuration name can\'t be empty',
  MODEL_TRAY_EMPTY: 'Configuration need at least one chosen tray',

  // Clients
  ROLE_EMPTY: 'Role can\'t be empty',
  PREFERENCE_EMPTY: 'Communication preference can\'t be empty',
  PARTNER_EMPTY: 'Partner can\'t be empty',
  COMMISION_EMPTY: 'Commision can\'t be empty',
  COMMISION_POSITIVE: 'Commision minimum zero',
  PAID_AMOUNT_EMPTY: 'Paid amount can\'t be empty',
  PAID_AMOUNT_POSITIVE: 'Paid amount minimum zero',
  BUSINESS_CATEGORY_EMPTY: 'Business category can\'t be empty',

  // Products
  UPC_EMPTY: 'UPC can\'t be empty',
  NAME_EMPTY: 'Name can\'t be empty',
  UNIT_EMPTY: 'Unit can\'t be empty',
  UNIT_POSITIVE: 'Unit minimum zero',
  UNIT_BATCH: 'Unit more than 1',
  IS_BATCH_EMPTY: 'Is Batch can\'t be empty',
  DESCRIPTION_EMPTY: 'Description can\'t be empty',
  CATEGORIES_EMPTY: 'Categories can\'t be empty',
  SAMS_CLUB_POSITIVE: 'Minimum zero',
  VISTAR_POSITIVE: 'Minimum zero',

  // Customer Support
  REFUND_AMOUNT_EMPTY: 'Refund amount can\'t be empty',
  REFUND_AMOUNT_POSITIVE: 'Refund amount minimum zero',
  REQUESTED_AMOUNT_EMPTY: 'Requested amount can\'t be empty',
  REQUESTED_AMOUNT_POSITIVE: 'Requested amount minimum zero',
  REFUND_REASON_EMPTY: 'Refund reason can\'t be empty',
  VM_EMPTY: 'Much choose one vending machine',
  SERVICE_DATE_EMPTY: 'Service date can\'t be empty',
  PART_PRICE_POSITIVE: 'Part price minimum zero',
  PART_PRICE_EMPTY: 'Part price can\'t be empty',
  PART_NAME_EMPTY: 'Part name can\'t be empty',
  LABOUR_HOUR_EMPTY: 'Labour hour can\'t be empty',
  LABOUR_HOUR_POSITIVE: 'Labour hour minimum zero',
  LABOUR_RATE_EMPTY: 'Labour rate can\'t be empty',
  LABOUR_RATE_POSITIVE: 'Part price minimum zero',
  BILL_AMOUNT_EMPTY: 'Bill amount can\'t be empty',
  BILL_AMOUNT_POSITIVE: 'Bill amount minimum zero',
  DISCOUNT_POSITIVE: 'Discount minimum zero',
  SERVICE_STATUS_EMPTY: 'Service status can\'t be empty',
  PRIORITY_EMPTY: 'Priority can\'t be empty',

  // Warehouse
  AISLE_NAME_EMPTY: 'Warehouse name can\'t be empty',
  AISLE_NEW_NAME_EMPTY: 'Warehouse new name can\'t be empty',
  LEVEL_EMPTY: 'Level can\'t be empty',
  LEVEL_POSITIVE: 'Level minimum zero',

  // Partner
  COMMISSION_AMOUNT_EMPTY: 'Commission Payment amount can\'t be empty',
  COMMISSION_AMOUNT_POSITIVE: 'Commission Payment amount minimum zero',
};

const successUpdateMsg = {
  SUCCESS_DELETE_CLIENT_BY_ROUTE_MSG: 'Success delete chosen client!',
  SUCCESS_DELETE_ROUTE_MSG: 'Success delete chosen route!',
  SUCCESS_DELETE_SCHEDULE_MSG: 'Success delete chosen schedule!',
  SUCCESS_DELETE_VM_MSG: 'Success delete chosen vending machine!',
  SUCCESS_REMOVE_VM_FROM_SCHEDULE_MSG: 'Vending Machine removed from the schedule!',
  SUCCESS_UPDATE_VM_COLUMN_MSG: 'Success update chosen vending machine column!',
  SUCCESS_DELETE_PRODUCT_MSG: 'Success delete chosen product!',
  SUCCESS_DELETE_MODEL_CONFIG_MSG: 'Success delete chosen model configuration!',
  SUCCESS_DELETE_CLIENT_CONTACT_MSG: 'Success delete chosen contact person!',
  SUCCESS_DELETE_CLIENT_PARTNER_MSG: 'Success delete chosen partner!',
  SUCCESS_PAID_CLIENT_INVOICE_MSG: 'Success paid chosen invoice!',
  SUCCESS_DELETE_CLIENT_MSG: 'Success delete chosen client!',
  SUCCESS_DELETE_USER_MSG: 'Success delete chosen user!',
  SUCCESS_RESTORE_USER_MSG: 'Success restore chosen user!',
  SUCCESS_DELETE_PARTNER_MSG: 'Success delete current partner!',
  SUCCESS_DELETE_COMMISSION_MSG: 'Success delete chosen commission!',
  SUCCESS_SET_PICKING_READY: 'Success set picking to ready!',
  SUCCESS_SET_DELIVERY_READY: 'Success set delivery to ready!',
  SUCCESS_SEND_REFUND: 'Success send refund!',
  SUCCESS_ADD_NEW_AISLE: 'Success add new aisle!',
  SUCCESS_UPDATE_AISLE: 'Success update aisle!',
  SUCCESS_ADD_PRODUCT_LEVEL: 'Success add product to current level!',
  SUCCESS_DELETE_ALL_PRODUCT_LEVEL: 'Success delete all product on current level!',
  SUCCESS_COPY_VM: 'Success copy chosen vending machine column!',
};

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
const DAY_OPTIONS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];
const ALPHABET: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

// Route Schedule
const ROUTE_STATUS = {
  DEFAULT: 0,
  READY_TO_PICKING: 1,
  READY_FOR_DRIVER: 2,
  IN_ROUTE: 3,
  ROUTE_SERVICED: 4,
  FINISH_PICKING: 5,
} as const;

const SCHEDULE_STATUS: { value: number, label: string }[] = [
  { value: ROUTE_STATUS.DEFAULT, label: 'Default' },
  { value: ROUTE_STATUS.READY_TO_PICKING, label: 'Ready to Picking' },
  { value: ROUTE_STATUS.READY_FOR_DRIVER, label: 'Ready for Driver' },
  { value: ROUTE_STATUS.IN_ROUTE, label: 'In Route' },
  { value: ROUTE_STATUS.ROUTE_SERVICED, label: 'Route Serviced' },
  { value: ROUTE_STATUS.FINISH_PICKING, label: 'Finish Picking' },
];

// Vending Machine
const VM_NUMBERING_OPTIONS = [
  { value: '0', label: 'Sequence' },
  { value: '1', label: 'Odd' },
  { value: '2', label: 'Even' },
];
const VM_TYPE_MODEL = [
  { value: 0, label: 'Snack' },
  { value: 1, label: 'Soda' },
  { value: 2, label: 'Combo' },
];

// Customer Support
const SERVICE_STATUS_OPTIONS: { value: number | null, label: string }[] = [
  { value: null, label: 'All' },
  { value: 1, label: 'Open' },
  { value: 2, label: 'Scheduled' },
  { value: 3, label: 'Closed' },
];
const REFUND_STATUS_OPTIONS: { value: 'PAID' | 'UNPAID' | null, label: string }[] = [
  { value: null, label: 'All' },
  { value: 'PAID', label: 'Paid' },
  { value: 'UNPAID', label: 'Unpaid' },
];
const SERVICE_REASON_OPTIONS = [
  { value: 1, label: 'Not Taking Bills' },
  { value: 2, label: 'Not Taking Coins' },
  { value: 3, label: 'Not Refunding Change' },
  { value: 4, label: 'Not Dispensing Product' },
  { value: 5, label: 'Product Stuck' },
  { value: 6, label: 'Water Leaking' },
  { value: 7, label: 'Product Not Cold' },
  { value: 8, label: 'Need Refill' },
  { value: 9, label: 'Other' },
];
const SERVICE_PRIORITY_OPTIONS = [
  { value: 1, label: 'Low' },
  { value: 2, label: 'Medium' },
  { value: 3, label: 'High' },
];
const CONTACT_ROLES = [
  { value: 0, label: 'Default' },
  { value: 1, label: 'Office Admin' },
  { value: 2, label: 'Account Billing' },
  { value: 3, label: 'Facility Manager' },
];
const COM_PREFERENCES = [
  { value: 0, label: 'Text' },
  { value: 1, label: 'Email' },
  { value: 2, label: 'Voice' },
];

export {
  COLOR_PRIMARY, yupErrorMsg, successUpdateMsg,
  ACCESS_TYPE, VENDING_URL, DAYS, DAY_OPTIONS, CONTACT_ROLES, MONTHS,
  ROUTE_STATUS, SCHEDULE_STATUS, ALPHABET, VM_NUMBERING_OPTIONS, VM_TYPE_MODEL,
  SERVICE_STATUS_OPTIONS, REFUND_STATUS_OPTIONS, COM_PREFERENCES,
  SERVICE_REASON_OPTIONS, SERVICE_PRIORITY_OPTIONS,
};
